// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingDescriptionPanel_root__2eI6H","form":"EditListingDescriptionPanel_form__v08Ki","title":"EditListingDescriptionPanel_title__3JEhD"};